// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const TemplateSectionOut = zod.object({
  "internal": zod.boolean(),
  "key": zod.string(),
  "position": zod.int(),
  "title": zod.string()
});

export type TemplateSectionOut = zod.input<typeof TemplateSectionOut>;
export type TemplateSectionOutOutput = zod.output<typeof TemplateSectionOut>;
